<!-- Заголовок с адаптивным дизайном -->
<div class="flex items-center">
  <div class="hidden md:flex items-center mr-2 md:mr-3">
    <button mat-icon-button
            matTooltip="Партнерская программа"
            [routerLink]="['/account/affiliate-program']">
      <fa-icon [icon]="faUserPlus" class="text-lg text-gray-500"></fa-icon>
    </button>
  </div>

  <div class="hidden md:flex items-center mr-2 md:mr-3">
    <button mat-icon-button
            matTooltip="Идеи пользователей"
            [routerLink]="['/ideas']">
      <fa-icon [icon]="faLightbulb" class="text-lg text-gray-500"></fa-icon>
    </button>
  </div>

  <div class="hidden md:flex items-center mr-2 md:mr-5">
    <button mat-icon-button
            matTooltip="Новости и обновления"
            [routerLink]="['/news']">
      <fa-icon [icon]="faNewspaper" class="text-lg text-gray-500"></fa-icon>
    </button>
  </div>

  <mat-divider class="hidden md:block h-6 mr-2 md:mr-5 border-gray-700" [vertical]="true"></mat-divider>

  <!-- Корзина -->
  <div class="flex items-center mr-2 md:mr-5">
    <button mat-button
            class="cart-icon"
            matTooltip="Ваш заказ на размещение рекламы"
            [@cartColorChange]="cartAnimationState"
            (@cartColorChange.done)="onAnimationDone($event)"
            [routerLink]="['advertiser/ad-order/create']">
      <mat-icon [svgIcon]="'ads_click'"></mat-icon>
      <!-- Сумма и количество -->
      <span class="flex items-center leading-none ml-2 whitespace-nowrap">
        <span>{{ (totalPrice$ | async) | currency: 'RUB' : '₽' }}</span>
        <sup class="text-gray-400 ml-1 flex items-center">
          {{ (adOrderItems$ | async)?.length }}
          <!-- Скрываем слово "площадок" на мобильных -->
          <span class="hidden md:inline">
            &nbsp;{{ (adOrderItems$ | async)?.length | declension:['площадка', 'площадки', 'площадок'] }}
          </span>
        </sup>
      </span>
    </button>
  </div>

  <!-- Баланс (скрываем текст на мобильных) -->
  <div class="flex items-center mr-2 md:mr-5">
    <button mat-button
            matTooltip="Детализация вашего баланса: доступно/заморожено"
            [routerLink]="['/account/finance/details']">
      <fa-icon [icon]="faWallet" class="text-xl text-gray-500"></fa-icon>
      <!-- Скрываем текст баланса на мобильных -->
      <span class="hidden md:flex items-center leading-none ml-2 whitespace-nowrap">
        <span>{{ user.money | currency:'RUB':'₽' }}</span>
        <sup class="text-gray-400 ml-1 flex items-center">
          <fa-icon [icon]="faLock" class="text-xs mr-1"></fa-icon>
          {{ user.moneyFrozen | currency:'RUB':'₽' }}
        </sup>
      </span>
    </button>
  </div>

  <!-- Пользователь (скрываем на мобильных) -->
  <div class="hidden md:flex items-center mr-2 md:mr-5">
    <button
      [routerLink]="['/account/settings']"
      mat-button>
      <img
        class="w-7 h-7 rounded-full"
        *ngIf="showAvatar && user.avatar"
        [src]="user.avatar"
      />
      <mat-icon
        *ngIf="!showAvatar || !user.avatar"
        [svgIcon]="'heroicons_outline:user-circle'"
        class="text-gray-500"
      ></mat-icon>
      <span class="flex items-center leading-none ml-2">
        <span>{{ user.name }}</span>
      </span>
    </button>
  </div>
</div>
